export const getMultiActionRowState = (allRows, getRowIsEditable, multiActionIds = []) => {
	const rows = allRows.filter(row => !row.getIsGrouped())
	const editableRows = getRowIsEditable ? rows.filter(getRowIsEditable) : rows
	const editableRowIds = editableRows.map(row => row.original.id)
	const allEditableRowsSelected = editableRows.length > 0 && editableRowIds.every(id => multiActionIds.includes(id))
	const someEditableRowsSelected = editableRowIds.some(id => multiActionIds.includes(id))

	return {
		editableRowIds,
		disabled: getRowIsEditable && editableRows.length === 0,
		checked: allEditableRowsSelected,
		indeterminate: someEditableRowsSelected && !allEditableRowsSelected,
	}
}
